import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/store';

import { NotificationObj, selectNotifications } from '../../../store/slices/notifications';
import { filterConversationsByType, setInboxChannel } from '../../../store/slices/chat';
import InboxItem from './InboxItem';
import WithLoader from '../../../components/WithLoader/WithLoader';
import Modal from '../../../components/UI/Modals/Modal';
import ModalComponent from './ModalComponent';
import classes from './Inbox.module.scss';
import { useTranslation } from '../../../hooks/useTranslations';
// import ChatDropdown from './ChatDropdown';
interface Props {
  style?: any;
}

type FiltersObj = {
  label: string;
  value: number | string;
};

const Inbox = ({ style }: Props) => {
  return <InboxComponent style={style} />;
};

const InboxComponent = ({ style }: Props) => {
  const { translations } = useTranslation();
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(selectNotifications);
  const { action } = useAppSelector((state) => state.chat);
  const { allConversations, currentConversation, filteredAllConversations, inboxChannel } =
    useAppSelector((state) => state.chat);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [colapsedAccordion, setColapsedAccordion] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<number | string>(1);

  // const accountInfo = useAppSelector<IAccountInfo>(selectAccountInfo);
  // const isMobileClinic = Boolean(accountInfo?.account_number === process.env.REACT_APP_VITAL_SIGN_LOCATION || accountInfo?.account_number === process.env.REACT_APP_PHARAMACY_KOLBERGER);

  const handleFilter = (filter: FiltersObj) => {
    dispatch(setInboxChannel(filter.value));
    dispatch(filterConversationsByType(filter.value));
  };

  const chattingNotifications = notifications
    .filter((el: NotificationObj) => el.type === 'chatting_message_received')
    .map((el: NotificationObj) => el.conversation_id);

  const medicalConversations = allConversations.filter(
    (el: any) => el.conversation_type_name === 'medical'
  );
  const operationalConversations = allConversations.filter(
    (el: any) => el.conversation_type_name === 'support'
  );
  const checkNotifications = (conversations: Array<any>) =>
    conversations.reduce(
      (a, c) => a + (chattingNotifications.includes(c.conversation_id) ? 1 : 0),
      0
    );

  const filters: Array<FiltersObj> = [
    { label: translations('all'), value: '' },
    { label: translations('medical'), value: 'medical' },
    { label: translations('operational'), value: 'support' },
  ];

  const tabs: Array<FiltersObj> = [
    {
      label: `${translations('all.messages')}`,
      value: 1,
    },
    // {
    //   name: `${translations('your.inbox')}`,
    //   value: 2,
    // },
  ];

  return (
    <div className={classes.inboxContainer}>
      <div className={classes.container} style={style}>
        {/* {isMobileClinic && !["dit", "staging"].includes(`${process.env.REACT_APP_ENV}`) && */}
        <>
          <div style={{ maxHeight: '201px', borderBottom: '1px solid #DBDFEA' }}>
            <div
              className={`${classes.mainContainer} ${classes.mainWrapper}`}
              style={{ borderBottom: '1px solid #DBDFEA', cursor: 'pointer' }}
              onClick={() => setColapsedAccordion(!colapsedAccordion)}
            >
              <p>{translations('channels')}</p>
              <i
                className={colapsedAccordion ? `${classes.arrow} ${classes.active}` : classes.arrow}
              ></i>
            </div>
            <div
              className={`${classes.mainContainer}`}
              style={
                colapsedAccordion
                  ? { display: 'none' }
                  : { flexDirection: 'column', alignItems: 'flex-start', padding: '5px' }
              }
            >
              {filters.map((el) => {
                const notifications =
                  el.value !== ''
                    ? checkNotifications(
                        el.value === 'medical' ? medicalConversations : operationalConversations
                      )
                    : 0;
                return (
                  <div
                    key={el.value}
                    onClick={() => handleFilter(el)}
                    className={
                      el.value === inboxChannel
                        ? `${classes.filterItem} ${classes.active}`
                        : `${classes.filterItem}`
                    }
                  >
                    {el.label}
                    {notifications > 0 && (
                      <div className={classes.notificationIndicator}>{notifications}</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div
            className={`${classes.mainContainer} ${classes.mainWrapper}`}
            style={{ borderBottom: '1px solid #DBDFEA' }}
          >
            <p style={{ margin: '10px 0px' }}>{translations('conversation')}</p>
            <i
              className={classes.plusIcon}
              onClick={() => {
                setOpenModal(!openModal);
              }}
            ></i>
          </div>
        </>
        {/* } */}
        <div className={classes.mainContainer}>
          <div className={classes.tabsWrapper}>
            {tabs.map((item, index) => (
              <div
                key={index}
                className={
                  item.value === selectedTab
                    ? `${classes.tab} ${classes.activeTab}`
                    : `${classes.tab}`
                }
                onClick={() => setSelectedTab(item.value)}
              >
                <div
                  className={
                    item.value === selectedTab
                      ? `${classes.tabTitle} ${classes.activeTab}`
                      : `${classes.tabTitle}`
                  }
                >
                  {item.label}
                </div>
                <div className={classes.itemsNum}>{filteredAllConversations?.length}</div>
              </div>
            ))}
          </div>
        </div>
        <div
          className={
            currentConversation?.conversation_status === 'C'
              ? `${classes.inboxBody} ${classes.closedConversaitonHeight}`
              : `${classes.inboxBody}`
          }
        >
          <WithLoader
            isLoading={action.status === 'loading' && action.actionType === 'GET_CONVERSATIONS'}
          >
            <>
              {/* <div className={classes.dropDownWrapper}>
          <ChatDropdown label={translations('open.messages')} />
          <ChatDropdown label={translations('newest')} />
        </div> */}
              {filteredAllConversations.length > 0 ? (
                filteredAllConversations.map((item: any, index: number) => (
                  <InboxItem
                    key={index}
                    currentConversationId={currentConversation?.conversation_id}
                    item={item}
                    notifications={notifications}
                  />
                ))
              ) : (
                <p>{translations('no.conversations.inbox')}</p>
              )}
            </>
          </WithLoader>
        </div>
      </div>
      <Modal
        header={translations('new.chat')}
        isOpen={openModal}
        onClose={() => setOpenModal(!openModal)}
        maxWidth={'400px'}
        containerPadding={'0px'}
        headerStyles={{ padding: '15px' }}
        divider
      >
        <ModalComponent onClose={() => setOpenModal(false)} />
      </Modal>
    </div>
  );
};

export default Inbox;
